"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewsletterSubscriptionType = void 0;
var NewsletterSubscriptionType;
(function (NewsletterSubscriptionType) {
    NewsletterSubscriptionType["MARKETING_NEWSLETTER"] = "MARKETING_NEWSLETTER";
})(NewsletterSubscriptionType || (exports.NewsletterSubscriptionType = NewsletterSubscriptionType = {}));
//# sourceMappingURL=newsletter.js.map